import { ClearRounded, DoneRounded } from "@mui/icons-material";
import { Button, Dialog, List, ListItem } from "@mui/material";

import HNSColors from "../../HNSColors";

export default function NewResponseModal({
  description,
  errorMessage,
  handleClose,
  isError,
  open,
  setOpen,
  title,
}) {
  const errorMessages = Array.isArray(errorMessage)
    ? errorMessage
    : errorMessage?.details
      ? Object.entries(errorMessage.details)
      : errorMessage
        ? [[errorMessage]]
        : [];

  const renderErrorContent = () => {
    if (!errorMessages.length || !errorMessages[0]) {
      return "Please try again";
    }

    return (
      <List>
        {errorMessages.map((issue, index) => (
          <ListItem key={index[0]} value={issue[0]}>
            {issue[0]} - {issue[1]}
          </ListItem>
        ))}
      </List>
    );
  };
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "8px",
          maxWidth: "300px",
        },
      }}
    >
      <div className="grid place-content-center place-items-center gap-4 px-4 py-8">
        <div
          className="w-fit rounded-full p-3"
          style={{
            border: `4px solid ${isError ? HNSColors.failure[500] : HNSColors.success[500]}`,
          }}
        >
          {isError ? (
            <ClearRounded
              sx={{
                fontSize: 40,
                color: HNSColors.failure[500],
                fontWeight: "bold",
              }}
            />
          ) : (
            <DoneRounded
              sx={{
                fontSize: 40,
                color: HNSColors.success[500],
                fontWeight: "bold",
              }}
            />
          )}
        </div>
        <h2 className="text-lg font-semibold">{title}</h2>
        {isError ? renderErrorContent() : <p className="text-center">{description}</p>}
        <Button
          sx={{
            background: HNSColors.secondary[500],
            "&:hover": {
              background: HNSColors.secondary[600],
            },
          }}
          className="w-full rounded-full py-[6px] text-sm normal-case transition"
          variant="contained"
          onClick={() => (handleClose ? handleClose() : setOpen(false))}
        >
          Continue
        </Button>
      </div>
    </Dialog>
  );
}
